import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '@config/environments/environment';
import { GOBACK_LOGGIN_PAGE_URL } from '@features/auth/const';
import { AuthSSOService } from '@features/auth/core/domain/sso-auth/auth-sso-web.service';
import { AuthService } from '@features/auth/public-api';
import { StorageHelper } from '@features/auth/shared/helpers/storage.helper';
import { getBackLinkToken, isExistBackLink, navigateToBackLink, navigateWithQueryParams } from '@features/auth/shared/redirect/redirect-helper';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  selector: 'app-finished-form',
  templateUrl: './finished-form.component.html',
  styleUrls: ['./finished-form.component.css'],
})
export class FinishedFormComponent {
  router = inject(Router);
  private readonly authService = inject(AuthService);

  onNavigateToHome() {
    // Check to to
    navigateToBackLink(this.router, 'token');
  }

  navigateToLogin() {
    // this.router.navigateByUrl(GOBACK_LOGGIN_PAGE_URL);
    navigateWithQueryParams(this.router, [GOBACK_LOGGIN_PAGE_URL]);
  }

  // TODO:
  onNavagateToSiteDaoTao() {
    window.location.href = environment.path.external_link.webDaoTao;
  }
}
